import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { fadeUp } from '../../utils/motion';
export function HomeCTA() {
  return <section className="bg-navy-deep text-white py-20 lg:py-28" data-id="element-370" data-mp="11zwg22v3jm33">
      <motion.div {...fadeUp} className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-371" data-mp="o410o6zwot4g">
        <h2 className="font-heading font-bold text-4xl lg:text-5xl tracking-tight mb-6" data-id="element-372" data-mp="t2ceestbnnry">
          Build a more intelligent future
        </h2>
        <p className="text-xl text-white/80 leading-relaxed mb-3" data-id="element-373" data-mp="1lq8gkd1nu7w4">
          Better decisions require more than access to data. They require
          connected evidence, capable people, and institutions willing to learn.
        </p>
        <p className="text-xl text-white leading-relaxed mb-10" data-id="element-374" data-mp="1bzncwb74qd6c">
          Let’s build those capabilities together.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-375" data-mp="1zoeygjq7rxa5">
          <a href="/contact" className="inline-flex items-center justify-center gap-2 bg-white text-navy hover:bg-surface-muted font-semibold px-6 py-3.5 rounded-md transition-colors duration-150 whitespace-nowrap" data-id="element-376" data-mp="24hrishnv1hx3">
            Request a Demo
            <ArrowRight size={18} data-id="element-377" data-mp="2e0m8exaw2429" />
          </a>
          <a href="/partnerships" className="inline-flex items-center justify-center border border-white/40 text-white hover:bg-white/10 font-semibold px-6 py-3.5 rounded-md transition-colors duration-150 whitespace-nowrap" data-id="element-378" data-mp="2e1dr57je07b4">
            Explore a Partnership
          </a>
        </div>
      </motion.div>
    </section>;
}